<template lang="html">
  <li @click="toServiceDetail(service.spuId, index)" class="service-item">
    <img :src="service.cmmdtyImage | viewImage(250, 150)" />
    <div class="info">
      <p class="name">{{ service.spuName }}</p>
      <p class="txt">
        <span v-if="service.workerCount > 0"
          >服务人员：{{ service.workerCount }}人</span
        >
        <span v-if="service.saleNum > 0"
          >历史服务：{{ service.saleNum }}次</span
        >
        <i v-else>&nbsp;</i>
      </p>
      <p v-if="service.businessName" class="businessName">
        {{ service.businessName }}
      </p>
      <div :class="skuItem.price" v-html="price"></div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    service: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number,
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {
    price() {
      if (
        this.service.maxPrice === this.service.minPrice ||
        this.service.maxPrice === '' ||
        this.service.minPrice === 0
      ) {
        return `<span>&yen;</span>${this.service.minPrice / 100}`
      } else {
        return `<span>&yen;</span>${
          this.service.minPrice / 100
        }~<span>&yen;</span>${this.service.maxPrice / 100}`
      }
    }
  },
  methods: {
    toServiceDetail(spuId, i) {
      const index = i + 1
      this.$$tracker('140101', '20000', '21127', index, spuId)
      location.href = `/v/product/${spuId}?refresh=no`
      // this.$router.push({
      //     name: 'product-detail',
      //     params: {
      //         spuId
      //     },
      //     query: {
      //         entity_id: this.$route.query.entity_id || this.$route.query.storeCode,
      //         refresh: 'no'
      //     }
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.service-item {
  display: flex;
  padding: rem(30px) rem(20px);
  background: #fff;
  @include border(bottom, #e5e5e5);

  &::after {
    left: rem(20px);
  }
  &:last-child {
    &::after {
      display: none;
    }
  }
  img {
    display: block;
    width: rem(250px);
    height: rem(150px);
  }
  .info {
    flex: 1;
    // padding: 0 rem(20px);
    margin-left: rem(20px);
    overflow: hidden;
    .name {
      max-height: rem(46px);
      color: #121212;
      font-size: rem(32px);
      line-height: rem(46px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .txt {
      margin-bottom: rem(10px);
      color: #666666;
      font-size: rem(24px);
      line-height: rem(36px);
      margin-top: rem(10px);

      > span {
        &::after {
          content: '';
          display: inline-block;
          width: 1px;
          height: rem(24px);
          margin: 0 rem(10px);
          vertical-align: text-bottom;
          border-right: 1px solid #666;
        }

        &:last-of-type {
          &::after {
            display: none;
          }
        }
      }
    }
    .businessName {
      font-size: rem(24px);
      color: #666666;
    }
  }
}
</style>
<style lang="scss" module="skuItem">
@import '../../assets/css/mixin';
.price {
  margin-top: rem(4px);
  width: 100%;
  color: #ff397e;
  font-size: rem(36px);
  span {
    margin-right: rem(4px);
    font-size: rem(28px);
  }
}
</style>
